module.exports = __webpack_public_path__ + "img/p1-desc.664dfc5c.jpg";